import { useActiveAccount, useActiveAccountLogo } from '@witmetrics/data-store';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import { useThemeMode } from '@/providers/ThemeModeProvider';
import { THEME_MODES } from '@/providers/ThemeModeProvider/constants';
import { MoonIcon, SunIcon } from '@/icons';
// import Button from '@/components/Button';
import HeaderLogo from '@/components/HeaderLogo';
// import ProfilePicture from '@/components/ProfilePicture';
import { classes, getActiveLogoUrl } from './utils';

export default function AppHeader() {
  const activeAccount = useActiveAccount();
  const logoValue = useActiveAccountLogo();
  const { mode, toggleMode } = useThemeMode();
  const logo = getActiveLogoUrl(activeAccount?.accountType, logoValue);

  return (
    <header className={classes.header}>
      <HeaderLogo src={logo || null} />
      <div className={classes.divider} />
      <span className={classes.storeLabel}>Store</span>
      {getEnv() === NODE_ENV.TESTING && (
        <div className={classes.testingWrapper}>
          <span>This is a testing version of witMetrics.</span>
          <a
            className={classes.testingLink}
            href="https://store.witmetrics.io/">
            Go to main site
          </a>
        </div>
      )}
      <div className={classes.spacer} />
      {/*<button type="button" className={classes.action} onClick={onTrackOrder}>*/}
      {/*  <TruckIcon />*/}
      {/*  Track order*/}
      {/*</button>*/}
      <button
        type="button"
        aria-label="Toggle theme"
        className={classes.themeToggle}
        onClick={toggleMode}>
        {mode === THEME_MODES.DARK ? <MoonIcon /> : <SunIcon />}
      </button>
      {/*{signedIn ? (*/}
      {/*  <div className={classes.account}>*/}
      {/*    <ProfilePicture size={36} user={SIGNED_IN_USER} />*/}
      {/*    <div className={classes.accountText}>*/}
      {/*      <div className={classes.accountName}>*/}
      {/*        {SIGNED_IN_USER.firstname} {SIGNED_IN_USER.lastname}*/}
      {/*      </div>*/}
      {/*      <div className={classes.accountPractice}>{SIGNED_IN_PRACTICE}</div>*/}
      {/*    </div>*/}
      {/*    <ChevronDownIcon size={15} className={classes.accountChevron} />*/}
      {/*  </div>*/}
      {/*) : (*/}
      {/*  <Button*/}
      {/*    className={classes.headerButton}*/}
      {/*    variant="outline"*/}
      {/*    onClick={onSignIn}>*/}
      {/*    Sign in*/}
      {/*  </Button>*/}
      {/*)}*/}
    </header>
  );
}
